import * as React from "react";
import { dic } from "elstr-jslib-4/dist/ElstrLanguage";

interface Props {}

interface ComponentState {
  secondsLeft: number;
}

class CheckoutTtiInfo extends React.Component<Props, ComponentState> {
  private intervalId: number | null = null;
  private timeoutId: number | null = null;
  private readonly targetUrl =
    "https://www.ttieurope.com/content/ttieurope/en.html";

  constructor(props: Props) {
    super(props);
    this.state = { secondsLeft: 10 };
  }

  componentDidMount() {
    this.intervalId = window.setInterval(() => {
      this.setState(prevState => ({ secondsLeft: prevState.secondsLeft - 1 }));
    }, 1000);

    this.timeoutId = window.setTimeout(() => {
      window.location.href = this.targetUrl;
    }, 50000);
  }

  componentWillUnmount() {
    if (this.intervalId) window.clearInterval(this.intervalId);
    if (this.timeoutId) window.clearTimeout(this.timeoutId);
  }

  decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  /*<h2 className="subtitle">{dic("KUNDENINFROMATION TTI")}</h2>*/
  render() {
    const rawHtml = dic('HINWEIS ZU TTI');
    const cleanHtml = this.decodeHtml(rawHtml);
    return (
      <div className="col">
        <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
        <br /><br />
        <button
          className="input--submit"
          onClick={() => (window.location.href = this.targetUrl)}
        >
          TTI Europe - Electronic Components Distributor | TTI Europe
        </button>
      </div>
    );
  }
}

export default CheckoutTtiInfo;
